import { Reveal, Eyebrow } from "@/components/Reveal";

export const LegalSection = ({ title, children }) => (
  <Reveal>
    <section className="mt-10">
      <h2 className="font-display text-xl font-extrabold tracking-tight text-coal sm:text-2xl">{title}</h2>
      <div className="mt-3 space-y-3 text-sm leading-relaxed text-coal-muted">{children}</div>
    </section>
  </Reveal>
);

export const LegalShell = ({ eyebrow, title, updated, children, testId }) => (
  <div className="bg-sand grain py-16" data-testid={testId}>
    <div className="mx-auto max-w-3xl px-6">
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-coal sm:text-5xl">{title}</h1>
        <p className="mt-3 text-xs text-coal-muted">Last updated: {updated}</p>
        <p className="mt-4 rounded-2xl border border-gold/40 bg-gold/10 px-5 py-3.5 text-xs leading-relaxed text-coal-muted">
          This document is a working draft prepared for EduPower Foundation and is currently being
          reviewed by a legal professional. It will be finalised once that review is complete.
        </p>
        <div className="mt-6 rounded-2xl border border-coal/10 bg-white p-6">
          <p className="font-heading text-sm font-bold text-coal">EduPower Foundation NPC</p>
          <p className="mt-1 text-sm text-coal-muted">Registration number: 2024/513680/0</p>
          <p className="text-sm text-coal-muted">Cape Town, Western Cape, South Africa</p>
          <p className="text-sm text-coal-muted">
            Email:{" "}
            <a href="mailto:admin@edupowerfoundation.org" className="font-semibold text-teal hover:text-ember">
              admin@edupowerfoundation.org
            </a>
          </p>
        </div>
      </Reveal>
      {children}
    </div>
  </div>
);
